import React from 'react';
import request from 'superagent';
import config from '../../../config';
import _ from 'lodash';
import moment from 'moment';

class ImpactSnapshot extends React.Component {
    state = {
        tomorrow: moment().add(1, 'day').format('YYYY-MM-DD'),
        currentWeek: [moment().add(-7, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')], //getCurrentWeek(),
        currentMonth: [moment().add(-30, 'days').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')], //getCurrentWeek(),
        new_accounts: 0,
        new_referrals: 0,

        app_ios_new_accounts: 0,
        app_android_new_accounts: 0,

        rc_ios_new_accounts: 0,
        rc_android_new_accounts: 0,

        rf_ios_new_accounts: 0,
        rf_android_new_accounts: 0,

        ad_ios_new_accounts: 0,
        ad_android_new_accounts: 0,

        daily_usage: 0,

    }

    componentWillMount() {
        const { snapshot_mode } = this.props;
        this.setState({ snapshot_mode }, () => {
            this.fetch();
        })
    }
    componentWillReceiveProps = nextProps => {
        const { snapshot_mode } = nextProps;
        if (snapshot_mode !== this.state.snapshot_mode) {
            this.setState({ snapshot_mode }, () => {
                this.fetch();
            })
        }
    }

    fetch = () => {

    }

    render() {
        const { snapshot_mode } = this.state, { videos } = this.props;

        // Filter videos based on snapshot_mode
        let filteredVideos = videos || [];
        const today = moment().format('YYYY-MM-DD');

        if (snapshot_mode === 1) {
            filteredVideos = filteredVideos.filter(v =>
                moment(v.createDate).format('YYYY-MM-DD') === today
            );
        } else if (snapshot_mode === 2) {
            const weekAgo = moment().subtract(7, 'days').startOf('day');
            filteredVideos = filteredVideos.filter(v =>
                moment(v.createDate).isSameOrAfter(weekAgo)
            );
        } else if (snapshot_mode === 3) {
            const monthAgo = moment().subtract(30, 'days').startOf('day');
            filteredVideos = filteredVideos.filter(v =>
                moment(v.createDate).isSameOrAfter(monthAgo)
            );
        }

        return <section>
            <div className="w3-content d-flex flex-row px-4 pt-4">
                <div className="card sheet w-100 p-4 shadow d-flex flex-column">
                    <span className="font-16">Total Videos</span>
                    <span className="font-60 align-self-center line1 mt-3 ">{filteredVideos?.length ?? 0}</span>
                </div>
                <div className="p-2" />
                <div className="card sheet w-100 p-4 shadow d-flex flex-column bg-info white">
                    <span className="font-16">In Process</span>
                    <span className="font-60 align-self-center line1 mt-3 ">{_.filter(filteredVideos || [], f => f.impact_date === null).length}</span>
                </div>
                <div className="p-2" />
                <div className="card sheet w-100 p-4 shadow d-flex flex-column bg-green white">
                    <span className="font-16 align-self-center">Ready</span>
                    <span className="font-60 align-self-center line1 mt-3 ">{_.filter(filteredVideos || [], f => f.impact_date !== null).length}</span>
                </div>
            </div>
        </section>
    }
}

export default ImpactSnapshot;
